import messages from "./lang/messages";
import dateTimeFormats from "./lang/dateTimeFormats";
import numberFormats from "./lang/numberFormats";

import { createI18n } from "vue-i18n";
let navigatorLanguage;
const defaultLanguage = navigator.language.split("-")[0]

if (
  defaultLanguage != "fr" &&
  defaultLanguage != "de"
) {
  navigatorLanguage = "fr";
} else {
  navigatorLanguage = defaultLanguage;
}

const locale = localStorage.getItem("lang") || navigatorLanguage;

const i18n = createI18n({
  fallbackLocale: "fr",
  legacy: false,
  locale,
  messages,
  dateTimeFormats,
  numberFormats,
});

console.log(i18n.global)

export default i18n
